import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(value): string {
    if (!value) {
      return "";
    }

    let div = document.createElement("div");
    div.innerHTML = value;
    div.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
    div.querySelectorAll("p, div, li, h1, h2, h3, h4, h5, h6, blockquote, tr").forEach((el) => {
      el.append("\n");
    });

    return (div.textContent || div.innerText || "").replace(/\n{3,}/g, "\n\n").trim();
  }

}
